var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuppeeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.957,
    r: 19,
    fill: "#F0EFA2",
    fillOpacity: 0.43
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_443_10425",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.95703,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_443_10425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0861 25.159C22.2323 25.0244 22.3122 24.8609 22.3258 24.6685C22.3393 24.4762 22.2729 24.3076 22.1267 24.1628L19.1317 21.007L19.1569 20.932H19.4092C20.3565 20.932 21.1353 20.6699 21.7454 20.1455C22.3554 19.6212 22.7149 18.9667 22.8237 18.182H23.3206C23.4634 18.182 23.5813 18.1329 23.6744 18.0348C23.7672 17.9366 23.8137 17.8174 23.8137 17.677C23.8137 17.5369 23.7672 17.4206 23.6744 17.3283C23.5813 17.2359 23.4634 17.1898 23.3206 17.1898H22.7985C22.748 16.8884 22.6483 16.6093 22.4994 16.3523C22.3506 16.0951 22.1642 15.8582 21.9405 15.6415H23.3206C23.4634 15.6415 23.5813 15.5924 23.6744 15.4943C23.7672 15.3961 23.8137 15.2769 23.8137 15.1368C23.8137 14.9964 23.7672 14.8801 23.6744 14.7878C23.5813 14.6954 23.4634 14.6493 23.3206 14.6493H16.4101C16.2485 14.6493 16.1104 14.7062 15.9958 14.82C15.8812 14.9337 15.8239 15.0709 15.8239 15.2315C15.8239 15.3922 15.8812 15.5264 15.9958 15.634C16.1104 15.7417 16.2485 15.7955 16.4101 15.7955H19.4014C19.9488 15.7955 20.3985 15.9231 20.7505 16.1783C21.1026 16.4333 21.3291 16.7704 21.43 17.1898H16.317C16.1742 17.1898 16.0563 17.2389 15.9632 17.337C15.8704 17.4352 15.8239 17.5544 15.8239 17.6948C15.8239 17.8349 15.8704 17.9512 15.9632 18.0435C16.0563 18.1359 16.1742 18.182 16.317 18.182H21.4552C21.3673 18.6372 21.143 19.008 20.7825 19.2945C20.4222 19.581 19.9462 19.7243 19.3547 19.7243H18.1437C17.9434 19.7243 17.77 19.7711 17.6237 19.8648C17.4773 19.9583 17.3685 20.0871 17.2974 20.2513C17.2262 20.4154 17.2042 20.5821 17.2313 20.7513C17.2585 20.9204 17.3414 21.0819 17.4798 21.2358L21.0904 25.134C21.2261 25.2789 21.3895 25.3529 21.5804 25.356C21.7712 25.3592 21.9397 25.2935 22.0861 25.159ZM19.8206 29.457C18.4942 29.457 17.2476 29.2077 16.0806 28.709C14.9136 28.2104 13.8985 27.5336 13.0353 26.6788C12.1721 25.8239 11.4887 24.8187 10.985 23.663C10.4815 22.5074 10.2297 21.2726 10.2297 19.9588C10.2297 18.6448 10.4814 17.4097 10.9847 16.2535C11.4881 15.0974 12.1712 14.0917 13.034 13.2365C13.8969 12.3814 14.9116 11.7043 16.0781 11.2053C17.2446 10.7064 18.4909 10.457 19.817 10.457C21.1434 10.457 22.39 10.7064 23.557 11.205C24.724 11.7037 25.7391 12.3804 26.6023 13.2353C27.4655 14.0901 28.1489 15.0954 28.6526 16.251C29.1561 17.4067 29.4079 18.6414 29.4079 19.9553C29.4079 21.2693 29.1562 22.5044 28.6528 23.6605C28.1495 24.8167 27.4664 25.8224 26.6036 26.6775C25.7407 27.5327 24.726 28.2098 23.5595 28.7088C22.393 29.2076 21.1467 29.457 19.8206 29.457Z",
    fill: "#FECE07"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuppeeIcon);
export default __webpack_public_path__ + "static/media/RuppeeIcon.5e4796d01475ad00f20cac46e0238441.svg";
export { ForwardRef as ReactComponent };